import { useMutation } from "react-query";
import axios from "../axios";

type DownloadKatalogBody = {
    ukmId?: number;
    kategori: string;
    tipe: string;
};

const downloadKatalog = async (body: DownloadKatalogBody) => {
    const response = await axios.post<Blob>(
        "/api/downloadkatalog",
        body,
        { responseType: "blob" },
    );
    return response.data;
};

export default function useDownloadKatalog() {
    return useMutation((body: DownloadKatalogBody) => downloadKatalog(body));
}
